export default "__VITE_PUBLIC_ASSET__c5007be0__"